
export const colSubmissions = {
  classes: "w-10",
  dataField: "submissionDate",
  sort: true,
  text: "Submitted",
};
